import React from 'react'
import Header from './components/Header'
import Footer from './components/Footer'
import { ThemeProvider } from './components/ThemeProvider'

export const RootLayout = ({ children }) => {
  return (
    <ThemeProvider>
      <>
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
        <div className="flex flex-col min-h-screen relative overflow-hidden font-sans">
          <Header />
          <main className="flex-grow px-4 sm:px-0">
            {children}
          </main>
          <Footer />
        </div>
      </>
    </ThemeProvider>
  )
}